import Spinner from "../../spinner";
import {toastAlert} from "../../toastAlert";
import axios from "axios";
import {fillFormInputs} from "../../forms";

export const list = () => {
  if(window.IS_RSF_WORKER || window.IS_SUPERVISION_WORKER) {
    const modal = $("#addInventory_association_id__modalTransfer");

    modal.on('hide.bs.modal', async function() {
      // load templates applicable to the selected associations

      const form = $("#addInventory")

      const association_id = form.find('[name^="association_id["]').map((index, element) => {
        return $(element).val()
      }).toArray()

      const spinner = new Spinner()
      try {
        const response = await axios.get(`/api/inventories/templates?association_id[]=${association_id.join('&association_id[]=')}`)

        if (response.data.code !== 200) {
          throw new Error();
        }

        const templateInput = form.find('[name="inventory_dictionary_template_id"]')
        const currentTemplate = templateInput.val()

        templateInput.empty()
        for(const template of response.data.templates) {
          templateInput.append(`<option value="${template.id}">${template.name}</option>`)
        }

        if(currentTemplate && templateInput.find(`option[value="${currentTemplate}"]`).length) {
          templateInput.val(currentTemplate)
        } else {
          templateInput.val(templateInput.find('option:first').val())
        }
      } catch(err) {
        console.log(err)
        toastAlert('Niepowodzenie przy wykonywaniu operacji', {type: "danger"})
      } finally {
        spinner.destroy()
      }
    })
  }
}